import { createReducer, on } from '@ngrx/store';

import { BOGOF_STORE_API_ACTIONS } from './bogof.action';
import { BOGOF_STORE_INITIAL_STATE, BogofState } from './bogof.state';

export const BOGOF_STORE_REDUCER = createReducer(
  BOGOF_STORE_INITIAL_STATE,

  on(BOGOF_STORE_API_ACTIONS.loadBogofLoading, (state): BogofState => ({
    ...state,
    isLoading: true,
    hasError: false,
    error: null,
  })),

  on(BOGOF_STORE_API_ACTIONS.loadBogofSuccess, (state, data): BogofState => ({
    ...state,
    data,
    isLoading: false,
    isLoaded: true,
    hasError: false,
    error: null,
  })),

  on(BOGOF_STORE_API_ACTIONS.loadBogofFailure, (state, { error }): BogofState => ({
    ...state,
    isLoading: false,
    hasError: true,
    error,
  })),
);
